/**
 * The unmissable banner (phase3 doc § 6.4, fence 3).
 *
 * **Permanent while the shim is active** — no dismiss button, on every screen, at
 * the top of the layout rather than floating over content it might cover. The
 * requirement it satisfies is specific: *a screenshot taken in dev mode should be
 * obviously a dev-mode screenshot*, because screenshots of this app will end up in
 * emails and in a G3 meeting, and one that looks like a signed-in manager but is
 * not would mislead the people signing off.
 *
 * It renders nothing when the shim is inactive, so it costs a production build
 * nothing: `DEV_SHIM_COMPILED_IN` is a build-time literal and `devShimActive` is
 * false in a bundle without the shim.
 */
import { useAuth } from "./AuthContext";
import { DEV_SHIM_COMPILED_IN } from "./devShim";

export function DevAuthBanner() {
  const { devShimActive, devUpn } = useAuth();
  // Build-time literal first, for the same reason as `SignIn`: this returns
  // before any of the markup below is reachable in a production build, so the
  // banner's words are absent from that bundle rather than merely unrendered.
  if (!DEV_SHIM_COMPILED_IN) return null;
  if (!devShimActive) return null;

  return (
    <div className="dev-banner" role="alert" data-testid="dev-auth-banner">
      <strong>DEV AUTH — NOT SIGNED IN.</strong>{" "}
      {devUpn ? (
        <>
          Acting as <code>{devUpn}</code> from an unverified header.
        </>
      ) : (
        <>No identity chosen yet.</>
      )}{" "}
      Nobody has proven who they are; the backend is trusting a header. Never on
      inventory.cubanbread.com.
    </div>
  );
}
